export const addresses = {
  starAddress:"0x232A4710D1A21AfEfB021654C5B48092e5faB67F",
}
